module.exports = __webpack_public_path__ + "static/media/drip.2cdbd1ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/drip.jpg
// module id = 220
// module chunks = 0